<template>
    <div class="table-list booking">
        <!-- <verified-alarm-modal></verified-alarm-modal> -->
        <div class="mask"></div>
        <!-- <div class="btn-group">
            <rent-select refName="booking" selectMsg="所有狀態" :setDefault="isDefault" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff">
                <ul>
                    <li data-id="1">
                        房東簽約
                    </li>
                    <li data-id="2">
                        租客簽約
                    </li>
                    <li data-id="7">
                        租客付押金
                    </li>
                </ul>
            </rent-select>
            <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
        </div> -->
        <task-menu :isOpen="taskMenu" :taskHouseInfo="taskHouseInfo" @taskClose="closeTaskMenu"></task-menu>
        <div class="table-list-title">
            <span class="progress">房源地址、進度</span>
            <span class="name">房源名稱</span>
            <span class="tenant-phone">租客電話</span>
            <span class="countdown">時間內簽約</span>
            <span class="agent">業務</span>
            <span class="rent">租金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && bookingList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <div v-else-if="bookingList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(house, index) in filterByWord" :key="index" >
                    <span class="progress">
                        <span class="address">{{house.address}}</span>
                        <span class="progress-bar">
                            <span class="progress-status" :class="{'active': house.contractStatus == 1}">
                                <div class="order">
                                    1
                                </div>
                                業務簽約
                            </span>
                            <span class="progress-hr"></span>
                            <span class="progress-status" :class="{'active': house.contractStatus == 2}">
                                <div class="order">
                                    2
                                </div>
                                租客簽約
                            </span>
                            <span class="progress-hr"></span>
                            <span class="progress-status" :class="{'active': house.contractStatus == 7}">
                                <div class="order">
                                    3
                                </div>
                                租客付押金
                            </span>
                        </span>
                    </span>
                    <span class="name">{{house.name}}</span>
                    <span class="tenant-phone">{{house.tenantPhone}}</span>
                    <span class="countdown">
                        <count-down :timeStamp="translateDate(house.confirmDueDate)"></count-down>
                    </span>
                    <span class="agent">{{house.agentName}}</span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <span v-if="house.contractStatus == 1" class="action" @click="openTaskMenu(), $analyticsBiz.logEvent('簽署合約', { screen_name: '簽署合約'})" :data-id="index">簽署合約</span>
                    <span v-else class="action" @click="getContract(house.contractCid), $analyticsBiz.logEvent('查看合約', { screen_name: '查看合約'})" :data-id="index">查看合約</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import CountDown from '@/components/widge/CountDown.vue';
import TaskMenu from '@/components/bussiness/widges/menu/bizTaskMenu.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import verifiedAlarmModal from '@/components/widge/verifiedAlarmModal.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizGetBookingTableList,
    baseDomain
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            bookingList: [],
            taskMenu: false,
            taskHouseInfo: {},
            contractStatus: '',
            filterEmpty: false,
            bookingDataEmpty: false,
            bookingDataError: false,
            isLoading: true,
            isDefault: false,
        }
    },
    mounted () {
        // this.$analyticsBiz.logEvent("預定管理-待簽署合約");
        this.getBookingList()
    },
    watch: {
        apiStatus: function () {
            if( this.apiStatus == 'update' ){
                this.getBookingList()
            }
        }
    },
    methods: {
        closeTaskMenu: function (value) {
            this.$store.commit('modalStatus/set_filter_mode', false)
            this.taskMenu = value
        },
        openTaskMenu: function () {
            if(this.userStatus == 1 || this.userStatus == 4 || this.userStatus == 6){
                this.$store.dispatch('setModalStatus', {state: true, type: 'verifiedAlarm'})
            }else{
                this.$store.commit('modalStatus/set_filter_mode', true)
                let bookingListId = event.target.dataset.id
                this.taskMenu = true
                this.taskHouseInfo = this.filterByWord[bookingListId]
                this.taskHouseInfo.empty = 1
                this.taskHouseInfo.status = [1]
            }
            
            // console.log(this.filterResult[bookingListId])
        },
        getSelectId: function (value) {
            this.isDefault = false

            if( value.ref == 'booking' ){
                this.contractStatus = value.id
            }
        },
        // setFilterWord: function (value) {
        //     this.isDefault = false
        //     this.filterWord = value
        // },
        setFilterDefault: function (value) {
            this.$store.dispatch('setBizBookingMgtFilterDefault')
        },
        getBookingList: function () {
            apiBizGetBookingTableList()
            .then(res => {
                this.isLoading = false
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setApiStatus', 'success')
                    if( res.data.result ){
                        if( res.data.result ){
                            this.bookingList= res.data.result
                        }else{
                            this.bookingDataEmpty = true
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        translateDate: function (date) {

            let currentDate = new Date(date)
            currentDate = currentDate.setHours(currentDate.getHours())

            return currentDate
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        ...mapGetters({
            apiStatus: 'GET_STATUS',
            userStatus: 'GET_USER_STATUS',
            bizAuth: 'GET_BIZ_AUTH',
            filterQuery: 'GET_BIZ_BOOKING_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_BOOKING_MGT_FILTER_WORD',
        }),
        filterByState: function () {
            return this.bookingList.filter((item) => {
                if( item.contractStatus == 1 ){
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByState.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.salesName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByRent: function () {
            return this.filterBySales.filter((item) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= item.rentPrice){
                            return item
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= item.rentPrice && this.filterQuery.rent[1] >= item.rentPrice ){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByCounty: function () {
            return this.filterByRent.filter((item) => {
                if(this.filterQuery.county){
                    if(item.county == this.filterQuery.county){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district == this.filterQuery.district ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByDistrict.filter((item) => {
                if( this.filterWord ){
                    if( item.name.includes(this.filterWord) || item.address.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
    },
    components: {
        CountDown,
        TaskMenu,
        RentSelect,
        TableSearch,
        verifiedAlarmModal,
        tableLoading
    }
}
</script>
<style lang="scss">
    .table-list.booking{
        .table-list-title .progress,
        .table-list-body ul li .progress{
            position: relative;
            width: 315px;
            margin-right: 36px;
            .address{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 210px;
            margin-right: 36px;
        }
        .table-list-title .tenant-phone,
        .table-list-body ul li .tenant-phone{
            width: 75px;
            margin-right: 36px;
        }
        .table-list-title .countdown,
        .table-list-body ul li > .countdown{
            width: 75px;
            margin-right: 36px;
        }
        .table-list-title .agent,
        .table-list-body ul li > .agent{
            width: 62px;
            margin-right: 36px;
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            text-align: right;
            width: 51px;
            margin-right: 45px;
        }
        .table-list-title .action,
        .table-list-body ul li .action{
            width: 62px;
        }
        .table-list-body ul li .progress{
            .address{
                display: block;
                margin-bottom: 12px;
            }
            .progress-bar{
                display: flex;
                align-items: center;
                .progress-status{
                    display: flex;
                    align-items: center;
                    border-radius: 4px;
                    border: solid 1px #e0dfde;
                    background-color: #ffffff;
                    color: #a19d9c;
                    padding: 5px 10px;
                    .order{
                        font-size: 12px;
                        margin-right: 4px;
                    }
                }
                .progress-status.active{
                    color: #3942b5;
                    border: solid 1px #3942b5;
                    background-color: rgba(57, 66, 181, 0.06);
                }
                .progress-hr{
                    width: 16px;
                    height: 1px;
                    background: #cacfcd;
                }
            }
        }
        .table-list-body ul li .countdown{
            color: #292625;
            font-weight: normal;
        }
        .table-list-body ul li .action{
            color: #ff9275;
            cursor: pointer;
        }
        > .btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: -70px;
            right: 0px;
            .biz-rent-select{
                width: 86px;
                background: #fff;
                padding: 14px 16px;
                margin-right: 10px;
            }
            .table-search{
                width: unset;
            }
        } 
    }
    // @media screen and (max-width: 1280px) {
    //     .table-list.booking{
    //         .table-list-title .progress,
    //         .table-list-body ul li .progress{
    //             margin-right: 96px;
    //         }
    //         .table-list-title .rent,
    //         .table-list-body ul li .rent{
    //             margin-right: 71px;
    //         }
    //         .table-list-title .name,
    //         .table-list-body ul li .name{
    //             margin-right: 51px;
    //         }
    //         .table-list-title .countdown,
    //         .table-list-body ul li > .countdown{
    //             margin-right: 86px;
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/bookingMgt/bookingmgt/BookingTableList.vue